import { render, staticRenderFns } from "./ModalRecord.vue?vue&type=template&id=562ee60c"
import script from "./ModalRecord.vue?vue&type=script&lang=js"
export * from "./ModalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports